import SupplierInbox from '../SupplierInbox.vue'

export default [
    {
        path: '/supplier_inbox',
        component: SupplierInbox,
        name: 'supplier_inbox',
    }
]